import { render, staticRenderFns } from "./SpeedList.vue?vue&type=template&id=72321523&scoped=true&"
import script from "./SpeedList.vue?vue&type=script&lang=ts&"
export * from "./SpeedList.vue?vue&type=script&lang=ts&"
import style0 from "./SpeedList.vue?vue&type=style&index=0&id=72321523&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72321523",
  null
  
)

export default component.exports